import {Card} from "../../../basic/card.tsx";
import {Button} from "../../../basic/button.tsx";
import {ArrowRight} from "lucide-react";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

interface WelcomeCardProps {
    onSupportClick: () => void;
}

export function WelcomeCard({onSupportClick}: WelcomeCardProps) {
    const {t} = useTranslationWithKeys();

    return (
        <Card className="p-6 shadow-sm border-border/50 bg-muted/30">
            <div className="flex items-center justify-between flex-wrap gap-4">
                <div>
                    <h3 className="mb-1">{t('dashboard.needHelp')}</h3>
                    <p className="text-muted-foreground">
                        {t('dashboard.helpDescription')}
                    </p>
                </div>
                <Button
                    variant="outline"
                    className="rounded-full"
                    onClick={onSupportClick}
                >
                    {t('dashboard.goToSupport')}
                    <ArrowRight className="h-4 w-4 ml-2"/>
                </Button>
            </div>
        </Card>
    );
}